import {
    BRAND_DEFAULTS,
    resolveAccent,
    resolveColor,
    resolveOptionalText,
    resolveText,
    resolveTextAccent,
    type BrandConfig,
} from './brand';

export type { BrandConfig };

const env = import.meta.env;

/**
 * Branding dell'app: ogni campo usa `VITE_*` da `.env` e cade sui default di
 * `src/app/brand.ts` quando la variabile è assente o vuota.
 * Fa eccezione `vat`: è opzionale e resta `undefined` se `VITE_APP_VAT` non è
 * definita, così il footer non mostra un fallback.
 *
 * I colori sono anche esposti come variabili CSS (`--brand-*`) iniettate in
 * `index.html` da `vite.config.ts`: Tailwind (`text-accent`, `bg-brand`) e lo
 * sfondo in `globals.css` seguono `.env` come il tema MUI.
 */
export const brand: BrandConfig = {
    name: resolveText(env.VITE_APP_NAME, BRAND_DEFAULTS.name),
    tagline: resolveText(env.VITE_APP_TAGLINE, BRAND_DEFAULTS.tagline),
    websiteUrl: resolveText(env.VITE_APP_SITE_URL, BRAND_DEFAULTS.websiteUrl),
    vat: resolveOptionalText(env.VITE_APP_VAT),
    credits: resolveText(env.VITE_APP_CREDITS, BRAND_DEFAULTS.credits),
    logo: resolveText(env.VITE_APP_LOGO, BRAND_DEFAULTS.logo),
    favicon: resolveText(env.VITE_APP_FAVICON, BRAND_DEFAULTS.favicon),
    colors: {
        primary: resolveColor(env.VITE_APP_PRIMARY, BRAND_DEFAULTS.colors.primary),
        secondary: resolveAccent(env.VITE_APP_SECONDARY, env.VITE_APP_PRIMARY),
        accent: resolveTextAccent(env.VITE_APP_ACCENT, env.VITE_APP_SECONDARY, env.VITE_APP_PRIMARY),
        background: resolveColor(env.VITE_APP_BACKGROUND, BRAND_DEFAULTS.colors.background),
        surface: resolveColor(env.VITE_APP_SURFACE, BRAND_DEFAULTS.colors.surface),
    },
};
